module.exports = __webpack_public_path__ + "static/media/branch-tea.ac030655.jpg";